/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class TheCageGameAssets {

    static BITMAP_FONT_OPEN_SANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_WIN_CAP_COUNT_UP = "MaxWinCountup";

    static BITMAP_FONT_MULTIPLIER_COUNTER = "NumbersMult";
    static BITMAP_FONT_WIN_WAYS_COUNTER = "NumbersWays";
    static BITMAP_FONT_WAYS_WON:string = "NumbersWaysWon";

    static BITMAP_FONT_BIRDS_RED:string = "NumbersBird";
    static BITMAP_FONT_BIRDS_GRAY:string = "NumbersBirdLock";
    static BITMAP_FONT_BIRDS_GOLD:string = "NumbersBirdGolden";
    static BITMAP_FONT_BIRDS_SHADOW:string = "NumbersBirdShadow";
    static BITMAP_FONT_COINS:string = "NumbersCoins";

    public static MAIN_GAME_BACKGROUND:string = "resources/images/Intro_BG.jpg";
    public static get MAIN_GAME_BACKGROUND_TEXTURE():PIXI.Texture {
        return  ImgLoader.getImgTexture(TheCageGameAssets.MAIN_GAME_BACKGROUND);
    }

    static IMAGES_LOGO:string = "resources/images/introLogo.png";
    static get IMAGES_LOGO_TEXTURE():PIXI.Texture {
        return  ImgLoader.getImgTexture(TheCageGameAssets.IMAGES_LOGO);
    }

    static REEL_FRAME_BACKGROUND:string = "reel_bg";

    static L_SPINE:string = "spine/L_all.json";
    static M1_SPINE:string = "spine/M1.json";
    static M2_SPINE:string = "spine/M2.json";
    static M3_SPINE:string = "spine/M3.json";
    static M4_SPINE:string = "spine/M4.json";
    static M5_SPINE:string = "spine/M5.json";
    static WB_SPINE:string = "spine/WB.json";
    static BN_SPINE:string = "spine/BN.json";
    static S_SPINE:string = "spine/S.json";
    static SCATTER_ATTENTION:string = "spine/scatterAttention.json";

    static WILD_MINING_SPINE:string = "spine/WildMining.json";

    static COUNTER_BACK_PLATE:string = "board";
    static COUNTER_GLOW:string = "objects/glowAsset";
    static WAYS_TEXT_COUNTER:string = "ways";

    static BIG_WIN_SPINE_LEVEL_1:string = "spine/bigWinLv1.json";
    static BIG_WIN_SPINE_LEVEL_2:string = "spine/bigWinLv2.json";
    static BIG_WIN_SPINE_LEVEL_3:string = "spine/bigWinLv3.json";
    static BIG_WIN_SPINE_LEVEL_4:string = "spine/bigWinLv4.json";
    static BIG_WIN_SPINE_LEVEL_5:string = "spine/bigWinLv5.json";
    static MAX_WIN:string = "spine/wincap_pixelfight.json";

    static BIG_WIN_FRAME:string = "bigWin/BigWin_theme";
    public static GOLD_COIN_PARTICLE_ANIMATION:string = "GOLD_COIN_PARTICLE_ANIMATION";

    static PARTICLE_TRAIL:string = "trailParticle";

    static BREAK_WOOD_ANIMATION:string = "BREAK_WOOD_ANIMATION";

    static BASEGAME_BACKGROUND_EFFECTS:string = "spine/BaseGameBackGround.json";
    static FREESPINS_BACKGROUND_LVL1:string = "spine/FS-BG-Lev1.json";
    static FREESPINS_BACKGROUND_LVL2:string = "spine/FS-BG-Lev2.json";
    static FREESPINS_BACKGROUND_LVL3:string = "spine/FS-BG-Lev3.json";
    static FREESPINS_BACKGROUND_LVL4:string = "spine/FS-BG-Lev4.json";
    static FREESPINS_BACKGROUND_LVL5:string = "spine/FS-BG-Lev5.json";

    static FreespinsOpponent1:string = "spine/M5Fighter.json";
    static FreespinsOpponent2:string = "spine/M4Fighter.json";
    static FreespinsOpponent3:string = "spine/M3Fighter.json";
    static FreespinsOpponent4:string = "spine/M2Fighter.json";
    static FreespinsOpponent5:string = "spine/M1Fighter.json";

    static FREESPINS_FIGHTER_FIGHT:string = "FS/fStexter/FIGHT";
    static FREESPINS_FIGHTER_NAME_1:string = "FS/fStexter/BIGFATTY";
    static FREESPINS_FIGHTER_NAME_2:string = "FS/fStexter/IRONJAW";
    static FREESPINS_FIGHTER_NAME_3:string = "FS/fStexter/ONEGLOVEMAN";
    static FREESPINS_FIGHTER_NAME_4:string = "FS/fStexter/THECONTRICTOR";
    static FREESPINS_FIGHTER_NAME_5:string = "FS/fStexter/LITTLEDRAGON";
    static FREESPINS_FEATURE_NAME_1:string = "FS/fStexter/BOTHWAYS";
    static FREESPINS_FEATURE_NAME_2:string = "FS/fStexter/x2MULTIPLIER";
    static FREESPINS_FEATURE_NAME_3:string = "FS/fStexter/SYMBOLTRANSFORM";
    static FREESPINS_FEATURE_NAME_4:string = "FS/fStexter/STICKYWILD";
    static FREESPINS_SPINS_TEXT:string = "FS/fStexter/TITLEFIGHTSPINS";
    static FREESPINS_SPINS_ADD8:string = "FS/fStexter/8";
    static FREESPINS_SPINS_PLUS3:string = "FS/fStexter/plus3";
    static FREESPINS_SPINS_PLUS4:string = "FS/fStexter/plus4";
    static FREESPINS_SPINS_PLUS5:string = "FS/fStexter/plus5";
    static FREESPINS_INTRO_ANIMATIONS:string = "spine/FS_intro.json";

    static FS_REEL_FRAME:string = "FS-Frame";

    static FS_COUNTER_BACKGROUND = "meeters/meeter5Steps";
    static FS_COUNTER_BLUE_LIGHT = "meeters/blueLight";
    static FS_COUNTER_RED_LIGHT = "meeters/redLight";
    static FS_COUNTER_DELIM = "meeters/delimitation";
    static FS_LIFE_COUNTER = "spine/meter_effect.json";
    static FS_LIFE_BLINK = "spine/tickAttention.json";
    static FS_COUNTER_EXPLOSION = "spine/FS_meter_explosion.json";

    static FSFeaturesMulti:string = "FS/FSFeatures/FSFeatureFrame1";
    static FSFeaturesInfection1:string = "FS/FSFeatures/FSFeatureFrame2";
    static FSFeaturesInfection2:string = "FS/FSFeatures/FSFeatureFrame3";
    static FSFeaturesStickyWild:string = "FS/FSFeatures/FSFeatureFrame4";
    static FS_FEATURE_FRAME:string = "spine/FS_feature4.json";
    static FS_REEL_EFFECT:string = "spine/fs_reel_effect.json";


    static FS_OUTRO_SIGN_LOW:string = "FS/outroBad";
    static FS_OUTRO_SIGN_MID:string = "FS/outroBasic";
    static FS_OUTRO_SIGN_HIGH:string = "FS/outroGood";

    static FS_OUTRO_TITLE_LOW:string = "fsTransition/outroTitleBad";
    static FS_OUTRO_TITLE_MID:string = "fsTransition/outroTitleBasic";
    static FS_OUTRO_TITLE_HIGH:string = "fsTransition/outroTitleGood";
//
//    static FS_OUTRO_LEV1:string = "FS/FSOutros/outroLev0";
//    static FS_OUTRO_LEV2:string = "FS/FSOutros/outroLev1";
//    static FS_OUTRO_LEV3:string = "FS/FSOutros/outroLev2";
//    static FS_OUTRO_LEV4:string = "FS/FSOutros/outroLev3";
//    static FS_OUTRO_LEV5:string = "FS/FSOutros/outroLev4";

    static FS_OUTRO_LEV1:string = "spine/FSOutro_Lev0.json";
    static FS_OUTRO_LEV2:string = "spine/FSOutro_Lev1.json";
    static FS_OUTRO_LEV3:string = "spine/FSOutro_Lev2.json";
    static FS_OUTRO_LEV4:string = "spine/FSOutro_Lev3.json";
    static FS_OUTRO_LEV5:string = "spine/FSOutro_Lev4.json";


    static FS_COLLECT_AREA:string = "FS/collect_area";
    static MULTIPLIER_UPDATE:string  = "MULTIPLIER_UPDATE";
    static KILL_HISTORY_BACKPLATE:string = "killed_bg";
    static KILL_HISTORY_SHADOW:string = "killed_bg_shadow";
    static S2_INTRO_GLOW:string = "FS/starGlowA";



    static getKillBadgeTexture(name:string, attribute:string) {
        if (attribute == "" || attribute == "NONE"){
            return "fsTransition/killIcons/" + name;
        } else {
            return "fsTransition/killIcons/" + name + "_" + attribute;
        }
    }

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro:[],

        main:[
            {
                name:"fonts",
                assets:[
                    new BitmapFontAsset(TheCageGameAssets.BITMAP_FONT_OPEN_SANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(TheCageGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(TheCageGameAssets.BITMAP_FONT_WIN_CAP_COUNT_UP, "fonts/bitmapfonts/MaxWinCountup.fnt"),
                    new BitmapFontAsset(TheCageGameAssets.BITMAP_FONT_MULTIPLIER_COUNTER, "fonts/bitmapfonts/NumbersMult.fnt"),
                    new BitmapFontAsset(TheCageGameAssets.BITMAP_FONT_WIN_WAYS_COUNTER, "fonts/bitmapfonts/NumbersWays.fnt"),
                    new BitmapFontAsset(TheCageGameAssets.BITMAP_FONT_WAYS_WON, "fonts/bitmapfonts/NumbersWaysWon.fnt"),
                    new BitmapFontAsset(TheCageGameAssets.BITMAP_FONT_BIRDS_RED, "fonts/bitmapfonts/NumbersBird.fnt"),
                    new BitmapFontAsset(TheCageGameAssets.BITMAP_FONT_BIRDS_GRAY, "fonts/bitmapfonts/NumbersBirdLock.fnt"),
                    new BitmapFontAsset(TheCageGameAssets.BITMAP_FONT_BIRDS_GOLD, "fonts/bitmapfonts/NumbersBirdGolden.fnt"),
                    new BitmapFontAsset(TheCageGameAssets.BITMAP_FONT_BIRDS_SHADOW, "fonts/bitmapfonts/NumbersBirdShadow.fnt"),
                    new BitmapFontAsset(TheCageGameAssets.BITMAP_FONT_COINS, "fonts/bitmapfonts/NumbersCoins.fnt"),
                ]
            },
            {
                name:"spine",
                assets:[
                    new SpineAsset(TheCageGameAssets.BIG_WIN_SPINE_LEVEL_1, TheCageGameAssets.BIG_WIN_SPINE_LEVEL_1),
                    new SpineAsset(TheCageGameAssets.BIG_WIN_SPINE_LEVEL_2, TheCageGameAssets.BIG_WIN_SPINE_LEVEL_2),
                    new SpineAsset(TheCageGameAssets.BIG_WIN_SPINE_LEVEL_3, TheCageGameAssets.BIG_WIN_SPINE_LEVEL_3),
                    new SpineAsset(TheCageGameAssets.BIG_WIN_SPINE_LEVEL_4, TheCageGameAssets.BIG_WIN_SPINE_LEVEL_4),
                    new SpineAsset(TheCageGameAssets.BIG_WIN_SPINE_LEVEL_5, TheCageGameAssets.BIG_WIN_SPINE_LEVEL_5),
                    new SpineAsset(TheCageGameAssets.MAX_WIN, TheCageGameAssets.MAX_WIN),
                    new SpineAsset(TheCageGameAssets.L_SPINE, TheCageGameAssets.L_SPINE),
                    new SpineAsset(TheCageGameAssets.M1_SPINE, TheCageGameAssets.M1_SPINE),
                    new SpineAsset(TheCageGameAssets.M2_SPINE, TheCageGameAssets.M2_SPINE),
                    new SpineAsset(TheCageGameAssets.M3_SPINE, TheCageGameAssets.M3_SPINE),
                    new SpineAsset(TheCageGameAssets.M4_SPINE, TheCageGameAssets.M4_SPINE),
                    new SpineAsset(TheCageGameAssets.M5_SPINE, TheCageGameAssets.M5_SPINE),
                    new SpineAsset(TheCageGameAssets.WB_SPINE, TheCageGameAssets.WB_SPINE),
                    new SpineAsset(TheCageGameAssets.S_SPINE, TheCageGameAssets.S_SPINE),
                    new SpineAsset(TheCageGameAssets.WILD_MINING_SPINE, TheCageGameAssets.WILD_MINING_SPINE),
                    new SpineAsset(TheCageGameAssets.SCATTER_ATTENTION, TheCageGameAssets.SCATTER_ATTENTION),
                    new SpineAsset(TheCageGameAssets.BASEGAME_BACKGROUND_EFFECTS, TheCageGameAssets.BASEGAME_BACKGROUND_EFFECTS),
                    new SpineAsset(TheCageGameAssets.FREESPINS_BACKGROUND_LVL1, TheCageGameAssets.FREESPINS_BACKGROUND_LVL1),
                    new SpineAsset(TheCageGameAssets.FREESPINS_BACKGROUND_LVL2, TheCageGameAssets.FREESPINS_BACKGROUND_LVL2),
                    new SpineAsset(TheCageGameAssets.FREESPINS_BACKGROUND_LVL3, TheCageGameAssets.FREESPINS_BACKGROUND_LVL3),
                    new SpineAsset(TheCageGameAssets.FREESPINS_BACKGROUND_LVL4, TheCageGameAssets.FREESPINS_BACKGROUND_LVL4),
                    new SpineAsset(TheCageGameAssets.FREESPINS_BACKGROUND_LVL5, TheCageGameAssets.FREESPINS_BACKGROUND_LVL5),
                    new SpineAsset(TheCageGameAssets.FreespinsOpponent1, TheCageGameAssets.FreespinsOpponent1),
                    new SpineAsset(TheCageGameAssets.FreespinsOpponent2, TheCageGameAssets.FreespinsOpponent2),
                    new SpineAsset(TheCageGameAssets.FreespinsOpponent3, TheCageGameAssets.FreespinsOpponent3),
                    new SpineAsset(TheCageGameAssets.FreespinsOpponent4, TheCageGameAssets.FreespinsOpponent4),
                    new SpineAsset(TheCageGameAssets.FreespinsOpponent5, TheCageGameAssets.FreespinsOpponent5),
                    new SpineAsset(TheCageGameAssets.FS_FEATURE_FRAME, TheCageGameAssets.FS_FEATURE_FRAME),
                    new SpineAsset(TheCageGameAssets.FS_REEL_EFFECT, TheCageGameAssets.FS_REEL_EFFECT),
                    new SpineAsset(TheCageGameAssets.FS_OUTRO_LEV1, TheCageGameAssets.FS_OUTRO_LEV1),
                    new SpineAsset(TheCageGameAssets.FS_OUTRO_LEV2, TheCageGameAssets.FS_OUTRO_LEV2),
                    new SpineAsset(TheCageGameAssets.FS_OUTRO_LEV3, TheCageGameAssets.FS_OUTRO_LEV3),
                    new SpineAsset(TheCageGameAssets.FS_OUTRO_LEV4, TheCageGameAssets.FS_OUTRO_LEV4),
                    new SpineAsset(TheCageGameAssets.FS_OUTRO_LEV5, TheCageGameAssets.FS_OUTRO_LEV5),
                    new SpineAsset(TheCageGameAssets.BN_SPINE, TheCageGameAssets.BN_SPINE),
                    new SpineAsset(TheCageGameAssets.FS_LIFE_COUNTER, TheCageGameAssets.FS_LIFE_COUNTER),
                    new SpineAsset(TheCageGameAssets.FS_LIFE_BLINK, TheCageGameAssets.FS_LIFE_BLINK),
                    new SpineAsset(TheCageGameAssets.FS_COUNTER_EXPLOSION, TheCageGameAssets.FS_COUNTER_EXPLOSION),
                    new SpineAsset(TheCageGameAssets.FREESPINS_INTRO_ANIMATIONS, TheCageGameAssets.FREESPINS_INTRO_ANIMATIONS),
                ]
            },
            {
                name:"main",
                assets:[
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                ],
                animations: {
                    [TheCageGameAssets.GOLD_COIN_PARTICLE_ANIMATION] : "goldCoin/Gold_Coin_Loop_",
                    [TheCageGameAssets.BREAK_WOOD_ANIMATION] : "symbolLocks_blast/symbolLocks_blast_"
                }
            },
            {
                name:"mainJpeg",
                assets:[
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                ],
                animations: {
                    [TheCageGameAssets.MULTIPLIER_UPDATE] : "winMulteffect/winMulteffect_"
                }
            },
            {
                name:"noTinyPng",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new TextureAsset("noTinyPng0", "sheets/noTinyPng/noTinyPng0.json")
                ]
            },
            {
                name:"symbols",
                autoLoad:[AssetQualityLevel.HIGH],
                assets:[
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations:{}
            }
        ]
    };

}
